const accordionsHolders = document.querySelectorAll('.pdp-js-accordions');

if (accordionsHolders && !!accordionsHolders.length) {
    accordionsHolders.forEach(holder => {
        const accordions = holder.querySelectorAll('.pdp-accordion');

        accordions[0].classList.add('show-text');

        accordions.forEach(accordion => {
            const accordionBtn = accordion.querySelector('.pdp-accordion__header');
            const panel = accordion.querySelector('.pdp-accordion__panel');

            accordionBtn.addEventListener('click', () => {
                accordions.forEach(otherAccordion => {
                    if (otherAccordion !== accordion) {
                        otherAccordion.classList.remove('show-text');
                        otherAccordion.querySelector('.pdp-accordion__panel').style.maxHeight = null;
                    }
                });

                accordion.classList.toggle('show-text');
                panel.style.maxHeight = accordion.classList.contains('show-text') ? panel.scrollHeight + 40 + 'px' : null;
            });
        })
    });
}
